import PreviewButton from "../PreviewButton";
import TaskInformation from "../TaskInformation";
import ContractData from "./ContractData";
import React, {useEffect, useRef, useState} from "react";
import Paper from "@material-ui/core/Paper";
import {useDispatch, useSelector} from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {completeTask, getTask} from "../../../store/action/taskAction";
import {
    createReplacementCarRequest,
    getClaimReparationMissions,
    updateServiceProposal,
    getServiceProposalById
} from "../../../store/action/claimManagement";
import {fetchClaimDataAppExpert} from "../../../store/action/claim";
import ValidationButton from "../ValidationButton";
import {useNavigate, useParams} from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";
import MaskedDecimalInput from "../../../utils/MaskedDecimalInput";
import { use } from "react";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        position: 'relative',
    },
    paper: {
        display: 'grid',
        gridTemplateRows: '0.5fr 1fr 1.5fr',
        gap: '20px',
        padding: '20px',
        borderRadius: '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
    },
    previewBtn: {
        position: 'absolute',
        //background: 'rgb(243, 246, 249)',
        right: '20px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    },
    firstPart: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '35px',
    },
    secondPart: {
        display: 'block',
    },
    thirdPart: {
        display: 'grid',
        gridTemplateColumns: '60% 40%',
        // gap: '5px',
        alignItems: 'center',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
    },
    tableHeader: {
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: 700,
        textAlign: 'left',
        color: 'rgba(70, 78, 95, 1)',
        paddingBottom: '10px',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
    },
    tableTh: {
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 600,
        color: 'rgba(181, 181, 195, 1)',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        textAlign: 'left',
        paddingLeft: '5px',
        paddingBottom: '12px',
        paddingTop: '12px',
    },
    tableRow: {
        padding: '0',
    },
    tableContent: {
        paddingLeft: '5px',
        textAlign: 'left',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        paddingBottom: '9px',
        paddingTop: '12px',
    },
    selectInput: {
        width: '70%',
        //padding: '10px',
        fontSize: '14px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        //marginTop: '5px',
        //marginBottom: '15px',
    },
    card: {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: 0,
        },
        minHeight: '200px',
    },
    cardItem: {
        display: 'flex',
        justifyContent: 'space-between',
        color: 'rgba(128, 128, 143, 1)',
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '13px',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        paddingBottom: '3px',
        paddingTop: '3px',
        alignItems: 'center'
    },
    optionText: {
        padding: "5px",
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: "70%",
        height: '36px',
        borderRadius: 4,
        marginBottom: "20px",
    },
    inputLabel: {
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputText: {
        border: '1px solid rgba(231, 231, 231, 1)',
        background: 'rgba(255, 255, 255, 1)',
        width: '176px',
        height: '36px',
        textAlign: 'right',
        borderRadius: '4px 0px 0px 0px',
        opacity: '1',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
}));

const ClientPartPayment = () => {
    const { taskId } = useParams();

    const navigate = useNavigate();
    const classes = useStyles();
    const dispatch = useDispatch(); 
    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const [clientDecision, setClientDecision] = useState("");
    const [customerPayment, setCustomerPayment] = useState("");
    const [subMotif, setSubMotif] = useState("");
    const [subMotifOptions, setSubMotifOptions] = useState([]);
    const [replacementCar, setReplacementCar] = useState(false);
    const [starClaimData, setStarClaimData] = useState(null);
    const [dataClientPart, setDataClientPart] = useState({
        franchise: "0.000",
        rp: "0.000",
        ceilingExceedance: "0.000",
        customerPayment: "0.000"
    });

    const currentUser = localStorage.getItem('username');
    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    const managementTypeReducer = useSelector((state) => state.taskReducer.taskList.find(task => task.taskId === taskId)?.variables?.managementType?.value);
    const [managementType, setManagementType] = useState(managementTypeReducer)

    const [camundaVariables, setCamundaVariables] = useState(task?.variables)
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)
    const [immatriculation, setImmatriculation] = useState(task?.variables?.immatriculation?.value)
    const [claimMissionExpertId , setClaimMissionExpertId] = useState()


    const [totalHT, setTotalHT] = useState(0);
    const [tva, setTva] = useState(0);

    const [reparationMissions, setReparationMissions] = useState([]);

    const [serviceProposalId , setServiceProposalId] = useState();
    const [serviceProposalObject ,setServiceProposalObject] = useState();
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    const getReparationMissions = async (infoSinistre) => {
        const claimReparationMissions = await dispatch(getClaimReparationMissions(infoSinistre));
        setReparationMissions(claimReparationMissions);
    };

    const getServiceProposal = async (serviceProposalId) => {
        let proposedService = await getServiceProposalById(serviceProposalId);
        setServiceProposalObject(proposedService);
        if (proposedService) {
            setDataClientPart({
                franchise: proposedService.franchise?.toString() || "0.000",
                rp: proposedService.rp?.toString() || "0.000",
                ceilingExceedance: proposedService.ceilingExceedance?.toString() || "0.000",
                customerPayment: proposedService.customerPayment?.toString() || "0.000"
            });
        } else {
            setDataClientPart({
                franchise: "0.000",
                rp: "0.000",
                ceilingExceedance: "0.000",
                customerPayment: "0.000"
            });
        }
    };

    const getClaimData = async (claimMissionExpertId) => {
        try {
             
            const data = await fetchClaimDataAppExpert(claimMissionExpertId); 
            setStarClaimData(data);
            if (data) {
                setTotalHT((data.damageCalculation._totalMO_HT) + (data.damageCalculation._totalFour_HT));
                setTva((data.damageCalculation._totalFour_TVA) + (data.damageCalculation._totalMO_TVA));
            }
        } catch (error) {
            console.error("Error fetching claim data:", error);
        }
    };
    const fetchTask = async () => {
        try {
            const response = await getTask(taskId, currentUser);
            setTask(response)
            setInfoSinistre(response?.businessKey)
            setImmatriculation(response?.variables?.immatriculation?.value)
            setCamundaVariables(response?.variables)
            setClaimMissionExpertId(response?.variables?.claimExpertId.value)
            setServiceProposalId(response?.variables?._proposedServiceId?.value)
            await getReparationMissions(response?.businessKey);
            await getServiceProposal(response?.variables?._proposedServiceId?.value) 
            await getClaimData(response?.variables?.claimExpertId.value);
        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };

    useEffect(() => {
        setDataClientPart({
            franchise: "0.000",
            rp: "0.000",
            ceilingExceedance: "0.000",
            customerPayment: "0.000"
        });
    }, []);

    const updatedataClientPart = (event) => {
        const { name, value } = event.target;

        // Allow empty string or valid number with up to 3 decimal digits
        const regex = /^\d*(\.|,)?\d{0,3}$/;

        // Normalize comma to dot
        const normalizedValue = value.replace(',', '.');

        if (regex.test(normalizedValue) || normalizedValue === '') {
            setDataClientPart(prevState => {
                const updatedState = {
                    ...prevState,
                    [name]: normalizedValue
                };

                // Auto-calculate customerPayment when franchise or ceilingExceedance changes
                if (name === "franchise" || name === "ceilingExceedance") {
                    const franchise = parseFloat(updatedState.franchise) || 0;
                    const ceilingExceedance = parseFloat(updatedState.ceilingExceedance) || 0;
                    const tvaValue = parseFloat(tva) || 0;
                    const vt = starClaimData ? parseFloat(starClaimData.damageCalculation._totalFour_VETUS) || 0 : 0;
                    const rp = parseFloat(updatedState.rp) || 0;

                    updatedState.customerPayment = (franchise + ceilingExceedance + tvaValue + rp + vt).toFixed(3);
                }

                return updatedState;
            });
        }
    };

    const handleValidation = async () => {
        const validationErrors = [];

        if (!clientDecision) {
            validationErrors.push("La décision du client est requise");
        }

        if (clientDecision === "REFUSAL" && !subMotif) {
            validationErrors.push("Un sous-motif est requis pour un refus");
        }

        if (task?.variables?.managementType.value !== "AUTOP" && replacementCar === "") {
            validationErrors.push("La décision concernant la voiture de remplacement est requise");
        }

         if (dataClientPart.customerPayment > (totalHT + tva)) {
            validationErrors.push("Paiement client ne peut pas dépasser le total HT + TVA");
        }

        const numericFields = ['franchise', 'rp', 'ceilingExceedance', 'customerPayment'];
        numericFields.forEach(field => {
            const value = parseFloat(dataClientPart[field]);
            if (isNaN(value)) {
                validationErrors.push(`Le champ ${field} doit être un nombre valide`);
            } else if (value < 0) {
                validationErrors.push(`Le champ ${field} ne peut pas être négatif`);
            }
        });

        if (clientDecision === "ACCEPTANCE") {
            const calculatedTotal =
                (starClaimData?.damageCalculation?._totalFour_VETUS || 0) +
                dataClientPart.franchise +
                dataClientPart.rp +
                (tva || 0) +
                dataClientPart.ceilingExceedance;
        }

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        try {
            const serviceProposalObject = {
                clientDecision,
                customerPayment: parseFloat(dataClientPart.customerPayment),
                franchise: parseFloat(dataClientPart.franchise),
                rp: parseFloat(dataClientPart.rp),
                ceilingExceedance: parseFloat(dataClientPart.ceilingExceedance)
            };
            await updateServiceProposal(serviceProposalId, serviceProposalObject);

            if (replacementCar === "true") {
                const acceptedReparationMissions = reparationMissions.filter(
                    mission => mission.repairerDecision === "ACCEPTANCE"
                );

                console.log("acceptedReparationMissions", acceptedReparationMissions);

                const replacementCarData = {
                    associatedClaimNumber: infoSinistre,
                    repairStartDate: acceptedReparationMissions.length > 0
                        ?  acceptedReparationMissions[0].estimatedReparationEntryDate
                        : null,
                    immobilizationDuration: starClaimData ? starClaimData?.claimData?.report?.immDays : "",
                    comment: ""
                };

                console.log("replacementCarData", replacementCarData);
                await dispatch(createReplacementCarRequest(replacementCarData));
            }

            setCamundaVariables( camundaVariables.existReplacementCarRequest = {
                "value": replacementCar,
                "type": "Boolean"
            });
            setCamundaVariables( camundaVariables.customerPayment = {
                "value": dataClientPart.customerPayment,
                "type": "Double"
            });


            setCamundaVariables(camundaVariables.serviceProposalClientDecision = {
                "value": clientDecision,
                "type": "String"
            });
            if (clientDecision === "REFUSAL") {
                setCamundaVariables(camundaVariables.serviceProposalRefusalMotif = {
                    "value": subMotif,
                    "type": "String"
                });
            }


            await dispatch(completeTask(taskId, currentUser, camundaVariables));
            navigate('/todo-list', { reload: true });
        } catch (error) {
            console.error("Error during validation process:", error);
            setErrors(["Une erreur s'est produite lors de la validation"]);
            setOpenErrorDialog(true);
        }
    };


    useEffect(  () => {
        if (task?.assignee === currentUser) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }
        
    }, [task]);
    useEffect(() => {
        
        fetchTask();
        
        
    }, []);

    useEffect(() => {
        if (clientDecision === "REFUSAL") {
            setReplacementCar(false);
              setSubMotifOptions(["Dossier non conforme/douteux","Véhicule déjà en cours de réparation / PEC chez un autre prestataire pour un autre sinistre","Le client veut réparer dans la maison mère (Voiture en garantie)","Dégâts importants : Véhicule destiné à l'épave","Le client ne veut pas payer sa part","Montant réparations inférieur à la franchise","Client injoignable","Pièces non disponibles","Client a son garage","Client ne veut pas attendre la date du RDV","Véhicule déjà réparé","Client n'a pas respecté la date du RDV","Transfert vers RGA suite à la demande du client","Transfert vers AUTOP suite à la demande du client"]);  
        } else {
            setSubMotifOptions([]);
            setSubMotif("");
        }
    }, [clientDecision]);
    useEffect(() => {
        console.log("ReplacementCar", replacementCar);
        console.log("isTaskClaimed", isTaskClaimed);
    }, [replacementCar, isTaskClaimed]);

    return (
        <div className={classes.root}>
            
                 
                <div style={{display: 'flex'}}>    
<div className={classes.mainContent}>
                <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed} />
                <Paper className={classes.paper}>
                    <div className={classes.firstPart}>
                        <table className={classes.table}>
                            <thead>
                            <tr className={classes.tableHeader}>
                                <th>Données Rapport</th>
                            </tr>
                            <tr>
                                <th className={classes.tableTh}>VN</th>
                                <th className={classes.tableTh}>VV</th>
                                <th className={classes.tableTh}>VT TND</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr className={classes.tableRow}>
                                <td className={classes.tableContent}>{starClaimData ? parseFloat(starClaimData.claimData.car.vn.toFixed(3)) : '-'}</td>
                                <td className={classes.tableContent}>{starClaimData ? parseFloat(starClaimData.claimData.car.vv.toFixed(3))  : '-'}</td>
                                <td className={classes.tableContent}>{starClaimData ? parseFloat(starClaimData.damageCalculation._totalFour_VETUS.toFixed(3))  : '-'}</td>
                            </tr>
                            </tbody>
                        </table>

                        <table className={classes.table}>
                            <thead>
                            <tr className={classes.tableHeader}>
                                <th colSpan="3">Données Devis</th>
                            </tr>
                            <tr>
                                <th className={classes.tableTh}>Total Sans Tax</th>
                                <th className={classes.tableTh}>TVA</th>
                                <th className={classes.tableTh}>TTC</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr className={classes.tableRow}>
                                <td className={classes.tableContent}>{totalHT?parseFloat(totalHT.toFixed(3)):'-'}</td>
                                <td className={classes.tableContent}>{tva? parseFloat(tva.toFixed(3)) :'-'}</td>
                                <td className={classes.tableContent}>{parseFloat(totalHT.toFixed(3))+parseFloat(tva.toFixed(3))}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className={classes.secondPart}>
                   {task &&
                        <ContractData  
                        policyNumber={task?.variables?.policyNumber?.value} 
                        occurrenceDate ={task?.variables?.occurrenceDate?.value} 
                        affectedWaranties ={task?.variables?.affectedWaranties?.value}
                    />
                   } 
                    </div>
                    <div className={classes.thirdPart}>
                        <div>
                            <div>
                                <label className={classes.inputLabel}>Décision du client</label><br/>
                                <select
                                    className={classes.inputContainer}
                                    name="clientDecision"
                                    value={clientDecision}
                                    onChange={(e) => setClientDecision(e.target.value)}
                                    disabled={isTaskClaimed}
                                >
                                    <option className={classes.optionText} value=""></option>
                                    <option className={classes.optionText} value="ACCEPTANCE">Accepté</option>
                                    <option className={classes.optionText} value="REFUSAL">Refusé</option>
                                </select>
                            </div>

                            {clientDecision === "REFUSAL" && (
                                <div>
                                    <label className={classes.inputLabel}>Sous Motif</label><br/>
                                    <select
                                        className={classes.inputContainer}
                                        name="subMotif"
                                        value={subMotif}
                                        onChange={(e) => setSubMotif(e.target.value)}
                                        disabled={isTaskClaimed}
                                    >
                                        <option className={classes.optionText} value=""></option>
                                        {subMotifOptions.map((option, index) => (
                                            <option key={index} className={classes.optionText} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            {clientDecision === "ACCEPTANCE" && task?.variables?.managementType.value !== "AUTOP" && (
                                <div>
                                    <label className={classes.inputLabel}>Demande de voiture de remplacement</label><br/>
                                    <select
                                        className={classes.inputContainer}
                                        name="replacementCar"
                                        onChange={(e) => setReplacementCar(e.target.value)}
                                        disabled={isTaskClaimed}
                                    >
                                        <option className={classes.optionText} value=""></option>
                                        <option className={classes.optionText} value="true">Oui, le client demande une voiture de remplacement</option>
                                        <option className={classes.optionText} value="false">Non, le client ne souhaite pas avoir une voiture de remplacement</option>
                                    </select>
                                </div>
                            )}
                        </div>

                        <div className={classes.card}>
                            <div className={classes.cardItem}><span>Vétusté</span>
                                <span>{starClaimData ? parseFloat(starClaimData.damageCalculation._totalFour_VETUS.toFixed(3)) : '-'}</span>
                            </div>
                            <div className={classes.cardItem}><span>Franchise</span>
                                <MaskedDecimalInput
                                    className={classes.inputText}
                                    name="franchise"
                                    value={dataClientPart.franchise}
                                    onChange={(value) => {
                                        setDataClientPart(prev => {
                                            const franchise = parseFloat(value) || 0;
                                            const ceilingExceedance = parseFloat(prev.ceilingExceedance) || 0;
                                            const tvaValue = parseFloat(tva) || 0;
                                            const vt = starClaimData ? parseFloat(starClaimData.damageCalculation._totalFour_VETUS) || 0 : 0;
                                            const rp = parseFloat(prev.rp) || 0;

                                            return {
                                                ...prev,
                                                franchise: value,
                                                customerPayment: (franchise + ceilingExceedance + tvaValue + rp + vt).toFixed(3)
                                            };
                                        });
                                    }}
                                    disabled={isTaskClaimed || managementType === 'RGA'}
                                />
                            </div>
                            <div className={classes.cardItem}><span>RP</span>
                                <MaskedDecimalInput
                                    className={classes.inputText}
                                    name="rp"
                                    value={dataClientPart.rp}
                                    onChange={(value) => {
                                        setDataClientPart(prev => {
                                            const franchise = parseFloat(prev.franchise) || 0;
                                            const ceilingExceedance = parseFloat(prev.ceilingExceedance) || 0;
                                            const tvaValue = parseFloat(tva) || 0;
                                            const vt = starClaimData ? parseFloat(starClaimData.damageCalculation._totalFour_VETUS) || 0 : 0;
                                            const rp = parseFloat(value) || 0;

                                            return {
                                                ...prev,
                                                rp: value,
                                                customerPayment: (franchise + ceilingExceedance + tvaValue + rp + vt).toFixed(3)
                                            };
                                        });
                                    }}
                                    disabled={isTaskClaimed || managementType === 'RGA'}
                                />
                            </div>
                            <div className={classes.cardItem}><span>TVA</span>
                                <span>{tva ? parseFloat(tva.toFixed(3)) : '-'}</span>
                            </div>
                            <div className={classes.cardItem}><span>Dépassement plafond</span>
                                <MaskedDecimalInput
                                    className={classes.inputText}
                                    name="ceilingExceedance"
                                    value={dataClientPart.ceilingExceedance}
                                    onChange={(value) => {
                                        setDataClientPart(prev => {
                                            const franchise = parseFloat(prev.franchise) || 0;
                                            const ceilingExceedance = parseFloat(value) || 0;
                                            const tvaValue = parseFloat(tva) || 0;
                                            const vt = starClaimData ? parseFloat(starClaimData.damageCalculation._totalFour_VETUS) || 0 : 0;
                                            const rp = parseFloat(prev.rp) || 0;

                                            return {
                                                ...prev,
                                                ceilingExceedance: value,
                                                customerPayment: (franchise + ceilingExceedance + tvaValue + rp + vt).toFixed(3)
                                            };
                                        });
                                    }}
                                    disabled={isTaskClaimed || managementType ==='RGA'}
                                />
                            </div>
                            <div className={classes.cardItem}>
                                <span style={{color: "rgba(60, 101, 86, 1)", fontFamily: 'Poppins', fontSize: '13px', fontWeight: 700}}>Part client</span>
                                <MaskedDecimalInput
                                    className={classes.inputText}
                                    name="customerPayment"
                                    value={dataClientPart.customerPayment}
                                    onChange={(value) => {
                                        updatedataClientPart({
                                            target: {
                                                name: "customerPayment",
                                                value: value
                                            }
                                        });
                                    }}
                                    disabled={isTaskClaimed || managementType ==='RGA'}
                                />
                            </div>
                        </div>
                    </div>
                </Paper>
</div>
                    <PreviewButton claimData={infoSinistre}
                                    immatriculation={immatriculation}
                    />
                </div>

            <ValidationButton taskId={taskId} handleValidation={() => isTaskClaimed ? null : handleValidation()}/>
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        </div>
    )
}

export default ClientPartPayment;
